var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"dashboard__container"},[(_vm.user)?_c('div',{staticClass:"dashboard__container--body flex flex-wrap"},[_c('img',{staticClass:"pa-3 galleryImage",attrs:{"src":_vm.user.id_card_path}})]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }